<modus-chip size="small"
            show-close
            value="{{value | translate}}"
            (closeClick)="onCloseClick()"></modus-chip>
